"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseSeo = require("./base-seo");

Object.keys(_baseSeo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _baseSeo[key];
    }
  });
});

var _gatsbySeo = require("./gatsby-seo");

Object.keys(_gatsbySeo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gatsbySeo[key];
    }
  });
});